export const JEGER_BETALINGSVALG = {
  storvilt: 'storvilt',
  smaavilt: 'smaavilt',
  utvidelse: 'utvidelse'
};
